import { render, staticRenderFns } from "./ClientAffiliateMemo.vue?vue&type=template&id=30a5523d&scoped=true&"
import script from "./ClientAffiliateMemo.vue?vue&type=script&lang=js&"
export * from "./ClientAffiliateMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a5523d",
  null
  
)

export default component.exports